import { Button } from "../ui/button";

interface PaywallDemoFooterProps {
  onBookDemo: () => void;
}

export const PaywallDemoFooter = ({ onBookDemo }: PaywallDemoFooterProps) => {
  return (
    <div className="relative overflow-hidden rounded-2xl border border-violet-100 bg-[linear-gradient(135deg,#F0EEFF_0%,#F5DCEB_100%)] px-5 py-3 shadow-[inset_0_1px_0_rgba(255,255,255,0.65)]">
      <div className="pointer-events-none absolute inset-0 opacity-30 [background-image:radial-gradient(rgba(111,91,185,0.28)_1px,transparent_1px)] [background-size:4px_4px]" />
      <div className="relative flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="min-w-0">
          <div className="mb-1 text-base font-semibold text-foreground">
            Need More Information?
          </div>
          <p className="max-w-[720px] text-sm leading-5 text-muted-foreground">
            Interested in exploring all the features Jurni provides? Have
            questions or feature requests? Schedule a demo, and our team will
            ensure you get the best experience tailored to your needs.
          </p>
        </div>
        <Button
          className="h-9 w-full flex-shrink-0 font-semibold shadow-[inset_0_1px_0_rgba(255,255,255,0.25),0_2px_4px_rgba(0,0,0,0.16)] sm:w-[160px]"
          onClick={onBookDemo}
        >
          Book a Demo
        </Button>
      </div>
    </div>
  );
};
